import React, { Component } from 'react';
import env from "./env";

import Current from "./Task/Current/Current";
import Last24h from "./Task/Last24h/Last24h";

class App extends Component{
    state = {
        timerTitles: []
    }

    devTeam = JSON.parse(env.teams.dev);


    timerTitles = (timerTitles) => {
        this.setState({timerTitles: timerTitles});
    }
    /*let list = {};
    let folder = {};
    let space = {};*/

    render() {
        return (
            <div className="App">
                <div className="row">
                    <Current devTeam={this.devTeam} timerTitles={this.state.timerTitles} />
                    <div className="col-4">

                    </div>
                </div>
                <div className="row">
                    <Last24h devTeam={this.devTeam} timerTitles={this.timerTitles} />
                </div>
            </div>
        );
    }
}

export default App;
